<h2 mat-dialog-title class="!text-xl !font-bold !mb-2">Alterar Categoria em Massa</h2>

<mat-dialog-content class="dialog-content">

    <app-alert-card type="info" class="mb-3 d-block">
        A categoria será <strong>substituída</strong> nos documentos de
        <strong>{{ qtdSelecionados }} parcela(s)</strong> selecionada(s).
    </app-alert-card>

    <div [formGroup]="model">
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Nova Categoria</mat-label>
            <mat-select formControlName="idCategoriaFinanceira">
                @for (cat of data.categoriasFinanceiras; track cat.idCategoriaFinanceira) {
                    <mat-option [value]="cat.idCategoriaFinanceira">{{ cat.descricao }}</mat-option>
                }
            </mat-select>
            @if (idCategoriaFinanceiraControl.hasError('required') && idCategoriaFinanceiraControl.touched) {
                <mat-error>Selecione uma categoria</mat-error>
            }
        </mat-form-field>
    </div>

</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions mt-4">
    <button mat-flat-button class="btn-secondary mr-2" (click)="cancelar()" [disabled]="isLoading">Cancelar</button>
    <button mat-flat-button class="btn-primary" (click)="confirmar()" [disabled]="isLoading">
        @if (isLoading) {
            <mat-spinner diameter="18" class="me-2"></mat-spinner>
        } @else {
            Salvar alterações
        }
    </button>
</mat-dialog-actions>
